const PAGE_SIZE = 5;
const PAGE_NUMBER = 1;

export default {
    PAGE_SIZE,
    PAGE_NUMBER
};